import { consoles, type GameConsole } from "../consoles";
import { ConsoleLogo } from "./ConsoleLogo";

interface ConsoleGridProps {
  onPick: (console: GameConsole) => void;
}

export function ConsoleGrid({ onPick }: ConsoleGridProps) {
  return (
    <div className="flex flex-col items-center h-full overflow-y-auto p-6">
      <div className="w-full max-w-2xl text-center">
        <h1 className="text-2xl font-semibold text-text-primary mb-1">Pick a console</h1>
        <p className="text-text-secondary text-sm mb-6">
          Choose a system, then bring your own ROM.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {consoles.map((console) => (
            <button
              key={console.id}
              type="button"
              onClick={() => onPick(console)}
              className="flex flex-col items-center justify-center gap-2 rounded-xl border border-border bg-surface-2 hover:bg-surface-3 hover:border-[#5865F2] transition-colors px-4 py-6 cursor-pointer focus:outline-none focus:border-[#5865F2]"
            >
              <span className="flex w-full items-center justify-center" style={{ height: "2.5rem" }}>
                <ConsoleLogo
                  logo={console.logo}
                  emoji={console.emoji}
                  name={console.name}
                  plate={console.logoPlate}
                  height="1.5rem"
                />
              </span>
              <span className="text-text-primary text-sm font-medium">{console.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
